import { useCms } from './cms-context'
import { SectionFrame } from './SectionFrame'
import { DEFAULT_ORDER, SECTION_COMPONENTS } from './registry'
import type { CmsSection } from './types'

/* A page, drawn from its layout.
 *
 * The home page used to be a list of eleven imports in a fragment. It is this
 * instead — the same eleven components, in whatever order the layout says,
 * with the ones switched off left out.
 *
 * The fallback matters as much as the happy path. With no layout at all — a
 * first visit while the API is down, or a browser that has never been here —
 * this renders the built-in order with empty content, and every section falls
 * back to the copy it was written with. The site is then exactly what it was
 * before the CMS existed, which is the only acceptable failure mode for the
 * front page of a business.
 */

const blank = (key: string): CmsSection => ({
  key,
  enabled: true,
  content: {},
  style: {},
  elements: [],
})

export function CmsPage() {
  const { layout } = useCms()

  const sections = layout?.sections ?? DEFAULT_ORDER.map(blank)

  return (
    <>
      {sections.map((section) => {
        const Component = SECTION_COMPONENTS[section.key]
        if (!Component) return null
        return <SectionFrame key={section.key} section={section} component={Component} />
      })}
    </>
  )
}
